import { useEffect, useState } from 'react';

const TICK_INTERVAL_MS = 1000 * 15;

export const useMinutesCountdown = (getMinutes: (date: Date) => number | null) => {
  const [minutesLeft, setMinutesLeft] = useState<number | null>(null);

  useEffect(() => {
    const update = () => setMinutesLeft(getMinutes(new Date()));

    update();
    const interval = setInterval(update, TICK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [getMinutes]);

  return minutesLeft;
};
